if (!customElements.get("custom-full-360-view")) {
  class Custom360View extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.handle = this.dataset.handle;

      this.bindEvents();
      this.applyInitialActiveState();
      this.bindDownloadButton();

      // MOBILE LAYOUT FIX
      this.handleMobileLayout();

      // LISTEN FROM CTA → 360
      document.addEventListener("variant:change", (e) => {
        if (e.detail.source === "360") return;

        const variantId = e.detail.variantId;

        const target = this.querySelector(
          `.c360-swatch-item[data-variant-id="${variantId}"]`,
        );

        if (target) {
          target.click();
        }
      });
    }

    // -------------------------
    // SWATCH EVENTS
    // -------------------------
    bindEvents() {
      this.querySelectorAll(".c360-swatch-item").forEach((el) => {
        el.addEventListener("click", (e) => {
          const parent = e.currentTarget;

          const id = parent.dataset.variantId;
          const color = parent.dataset.variantColor;

          if (!id) return;

          this.updateActiveState(parent);
          this.updateVariant(id, color);
        });
      });
    }

    updateActiveState(activeEl) {
      this.querySelectorAll(".c360-swatch-item").forEach((el) => {
        el.classList.remove("active");
      });

      activeEl.classList.add("active");

      const color = activeEl.dataset.variantColor;
      const pill = activeEl.querySelector(".c360-pill");

      if (pill && color) {
        pill.style.background = color;
      }

      const dropdown = document.querySelector(".state-selector");

      if (dropdown && color) {
        dropdown.style.background = color;
        dropdown.style.borderColor = color;
      }
    }

    applyInitialActiveState() {
      const active = this.querySelector(".c360-swatch-item.active");

      if (active) {
        const color = active.dataset.variantColor;
        const pill = active.querySelector(".c360-pill");

        if (pill && color) {
          pill.style.background = color;
        }

        const dropdown = document.querySelector(".state-selector");

        if (dropdown && color) {
          dropdown.style.background = color;
          dropdown.style.borderColor = color;
        }
      }
    }

    // -------------------------
    // DOWNLOAD BUTTON
    // -------------------------
    bindDownloadButton() {
      const btn = this.querySelector(".c360-download-btn");
      if (!btn) return;

      btn.addEventListener("click", (e) => {
        e.preventDefault();

        const url = btn.getAttribute("href");
        if (!url) return;

        const fileName = url.split("/").pop().split("?")[0];

        const a = document.createElement("a");
        a.href = url;
        a.setAttribute("download", fileName || "download");
        a.setAttribute("rel", "noopener");

        document.body.appendChild(a);
        a.click();
        a.remove();
      });
    }

    // -------------------------
    // MOBILE LAYOUT HANDLER
    // -------------------------
handleMobileLayout() {
  if (window.innerWidth > 768) return;

  const container = this.querySelector(".c360-variants");
  if (!container) return;

  if (container.querySelector(".c360-mobile-wrap")) return;

  const priceWrapper = container.querySelector(".bike-price-wrapper");
  const price = container.querySelector(".c360-price");
  const dropdownWrapper = container.querySelector(".state-selector-wrapper");
  const swatches = container.querySelectorAll(".c360-swatch-item");
  const downloadBtn = container.querySelector(".c360-download-btn");
  const separators = container.querySelectorAll(".c360-separator");

  if (!swatches.length) return;

  // Create wrapper for variants + download
  const mobileWrap = document.createElement("div");
  mobileWrap.className = "c360-mobile-wrap";

  // Insert wrapper after dropdown (or after price if dropdown doesn't exist)
  if (dropdownWrapper) {
    dropdownWrapper.insertAdjacentElement("afterend", mobileWrap);
  } else if (priceWrapper) {
    priceWrapper.insertAdjacentElement("beforeend", mobileWrap);
  } else {
    container.appendChild(mobileWrap);
  }

  // Hide all separators
  separators.forEach((sep) => {
    sep.style.display = "none";
  });

  // Move swatches into wrapper
  swatches.forEach((swatch) => mobileWrap.appendChild(swatch));

  // Only separator before download
  if (downloadBtn) {
    const separator = document.createElement("div");
    separator.className = "c360-separator c360-mobile-separator";

    mobileWrap.appendChild(separator);
    mobileWrap.appendChild(downloadBtn);
  }
}

    // -------------------------
    // LOADER
    // -------------------------
    showLoader() {
      this.classList.add("loading");
    }

    hideLoader() {
      this.classList.remove("loading");
    }

    // -------------------------
    // VARIANT UPDATE
    // -------------------------
    updateVariant(id, color) {
      const url = `/products/${this.handle}?variant=${id}&section_id=${this.sectionId}`;
      const container = this;

      const height = container.offsetHeight;
      container.style.height = height + "px";

      this.showLoader();

      fetch(url)
        .then((res) => res.text())
        .then((htmlText) => {
          const html = new DOMParser().parseFromString(htmlText, "text/html");
          const updated = html.querySelector("custom-full-360-view");

          if (updated) {
            setTimeout(() => {
              this.innerHTML = updated.innerHTML;

              this.bindEvents();
              this.bindDownloadButton();

              // re-apply mobile layout
              this.handleMobileLayout();

              if (window.CI360) {
                try {
                  window.CI360.destroy && window.CI360.destroy();
                } catch (e) {}

                window.CI360.init();
              }

              this.applyInitialActiveState();

              this.hideLoader();

              // DISPATCH TO CTA
              document.dispatchEvent(
                new CustomEvent("variant:change", {
                  detail: {
                    variantId: id,
                    source: "360",
                  },
                }),
              );

              setTimeout(() => {
                this.style.height = "auto";
              }, 400);
            }, 200);
          }

          history.replaceState(null, "", `?variant=${id}`);
        })
        .catch((err) => {
          console.error("Variant load error:", err);
          this.hideLoader();
        });
    }
  }

  customElements.define("custom-full-360-view", Custom360View);
}
